module.exports = __webpack_public_path__ + "static/loading.cb6da8a3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/kanburn/loading.gif
// module id = 262
// module chunks = 35783957827783 246384609461072